<template>
  <div
    class="header"
     :class="{
      'curr': openActive,
      'container-fluid': !['/','/index.html', '/bannerPage', '/stepPage', '/tempPage'].includes($route.path)
    }"
  >
   
    <h1 class="logo"><router-link to="/"></router-link></h1>
    <nav class="nav">
      <ul class="clearfix">
        <li><router-link to="/" exact>首页</router-link></li>
        <li><router-link to="/templates">模板</router-link></li>
        <li><router-link to="/service">价格</router-link></li>
        <li>
          <a 
            :href="isMobile ? 'https://m.cndns.com/domains/index.aspx' : 'https://www.cndns.com/cn/domain/'" 
            target="_blank">
            域名
          </a>
        </li>
        <li v-if="!isMobile"><a href="https://jsohelp.websitemanage.cn/" target="_blank">帮助</a></li>
        <!-- <li><a href="https://bbs.sitestar.cn/forum.php" target="_blank">论坛</a></li> -->
        <li v-if="!isMobile"><a href="https://www.sitestar.cn/" target="_blank">建站之星</a></li>
        <li v-if="!isMobile"><a href="https://www.cndns.com" target="_blank">美橙互联</a></li>
        <li v-if="isMobile"><a href="https://m.cndns.com/" target="_blank">美橙</a></li>
        <li><router-link to="/case">案例</router-link></li>
        <li><router-link :to="{path: '/news', query: {cid:'knowledge',page:'1'}}">资讯</router-link></li>
      </ul>
    </nav>
    <div class="headUser">
      <!-- <a :href="'https://www.sitestar.cn/member/login.aspx?b='+ statistics" target="_blank" class="pageBtn a" v-if="!isLogin">登录</a>
      <a :href="'https://www.sitestar.cn/member/registration.aspx?b='+ statistics" target="_blank" class="pageBtn b" v-if="!isLogin">注册</a> -->
      <router-link to="/login" class="pageBtn a" v-if="!isLogin">登录</router-link>
      <router-link to="/register" class="pageBtn b" v-if="!isLogin">注册</router-link>

      <router-link to="/user" class="pageBtn b" v-if="isLogin">{{ this.currentUnme }}</router-link>
      <a href="javascript:" target="_blank" class="pageBtn a" v-if="isLogin" @click.prevent="logout">退出</a>
    </div>
    <div class="navbar-toggle">
      <a href="javascript:" @click="navToggle"></a>
    </div>

    
  </div>
</template>

<script>
import { logout } from '@/api/user';
import deviceMixin from '@/mixins/device';
import uhiddenUtil from '@/utils/uhiddenUtil';

export default {
  mixins: [deviceMixin],
  data () {
    return {
      currentUnme:'',
      isLogin:false,
      openActive:false,
      key:this.$cookies.get('uuid'),
      user:{},      
      queryProid:this.$route.query.proid,
      statistics:this.$route.query.b, 
    }
  },

  mounted() {
   this.currentUnme=uhiddenUtil.getCurrentUnme();
   if(this.currentUnme){
    this.isLogin=true;
   }
  },

  methods: {
    navToggle(){
      if(this.openActive == false){
        this.openActive = true
        $('#fp-nav').hide()
        $('body').addClass('navOpen')
      }else{
        this.openActive = false
        $('#fp-nav').show()
        $('body').removeClass('navOpen')
      }
    },

    // 退出登录
    async logout(){ 
      try {
        const res = await logout();
        //console.log(res)
        if (res.data.code === '10000') {            
            $("#init").remove();
            var script = document.createElement('script');
            script.id="init";
            script.type = 'text/javascript';
            script.src = "https://js.sitestar.cn/init.aspx";
            document.head.appendChild(script);
      
            // 跳转到首页或登录页'/login'            
            this.$router.push('/login');

        } else {
          this.$message.error(res.data.message || '退出失败');
        }
      } catch (err) {
        console.error(err);
        this.$message.error('请求失败');
      }

     
    },

    
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Header.vue